/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, EventEmitter, Input} from '@angular/core';

@Component({
  selector: 'gp-modal-dynamic-confirm',
  template: `
    <div class="modal in" style="display: block;">
      <div class="modal-dialog"
           [ngClass]="{
           customClass: customClass,
           'modal-lg': size === 'lg',
           'modal-md': size === 'md',
           'modal-sm': size === 'sm'
           }">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i [ngClass]="getIconClass()"></i>
              {{ title | translate }}
            </h5>
            <button *ngIf="isCrossButtonVisible" class="close-button" (click)="close()">
              <i class="fa fa-light fa-times p-t-sm"></i>
            </button>
          </div>
          <div class="modal-body p-lg p-t-0">
            <div test-id="deleteOccurrenceModal" [innerHTML]="text | translate"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn p-x-md" [ngClass]="getConfirmButtonClass()" test-id="confirmButton" (click)="ok()">
              {{ confirmButton | translate }}
            </button>
            <button type="button" class="btn btn-secondary p-x-md" test-id="cancelButton" (click)="cancel()">
              {{ cancelButton | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./dynamic-confirm-modal.component.scss']
})

export class DynamicConfirmModalComponent {

  @Input()
  public size: string = '';

  @Input()
  public customClass = '';

  @Input()
  public title: string = '';

  @Input()
  public text: string = '';

  @Input()
  public confirmButton: string = '';

  @Input()
  public cancelButton: string = '';

  @Input()
  public icon = '';

  @Input()
  public isCrossButtonVisible = false;

  /**
   * Visual variant of the confirm (primary action) button.
   * - 'danger'  -> red/danger button (deletion / destructive actions)
   * - 'default' -> black button (save / neutral confirmations)
   * Modal action buttons intentionally never use the brand primary color.
   */
  @Input()
  public variant: 'danger' | 'default' = 'default';

  public result: EventEmitter<boolean> = new EventEmitter<boolean>();

  public iconMapping: { [key: string]: string } = {
    'triangle-exclamation': 'fa-duotone fa-triangle-exclamation',
    'diamond-exclamation': 'fa-duotone fa-diamond-exclamation',
    'file-pen': 'fa-regular fa-file-pen'
  };

  public getIconClass(): string {
    return this.iconMapping[this.icon] || 'fa-duotone fa-triangle-exclamation';
  }

  /**
   * Returns the css class for the confirm button depending on the variant.
   * Never returns btn-primary: modal actions use danger or black instead.
   */
  public getConfirmButtonClass(): string {
    return this.variant === 'danger' ? 'btn-danger' : 'btn-dark';
  }

  public ok() {
    this.result.emit(true);
    this.result.complete();
  }

  public cancel() {
    this.result.emit(false);
    this.result.complete();
  }

  public close() {
    this.result.complete();
  }
}
